//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LensdescriptionCard',
  props: {
    lens: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {

    description() {
      return this?.lens?.short_description || this?.lens?.description || '';
    },

    link() {
      return this?.lens?.page_type === 2 ? this?.lens?.external_link : `/lenses/${this?.lens.slug}`;
    }
  }
}
